import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components/macro';

const icons = {};

const IconEditWrapper = styled.div`
  display: flex;
  padding: 5px;
  background-color: rgba(40, 40, 46, 0.5);
  cursor: pointer;

  &:hover path {
    fill: rgba(255, 255, 255, 0.9);
  }
`;

icons.remove = (
  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 1L9 0 5 4 1 0 0 1l4 4-4 4 1 1 4-4 4 4 1-1-4-4" fill="#FFF" fillRule="evenodd" />
  </svg>
);

icons.settings = (
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 14v2h6v-2H0zM0 2v2h10V2H0zm10 16v-2h8v-2h-8v-2H8v6h2zM4 6v2H0v2h4v2h2V6H4zm14 4V8H8v2h10zm-6-4h2V4h4V2h-4V0h-2v6z" fill="#FFF" fillRule="evenodd" />
  </svg>
);

function MediaIcon(props) {
  return (
    <IconEditWrapper>
      {icons[props.type]}
    </IconEditWrapper>
  );
}

MediaIcon.propTypes = {
  type: PropTypes.oneOf(Object.keys(icons)),
};

export default MediaIcon;
